// extracted by mini-css-extract-plugin
export var button = "_na-2";
export var card = "_na-0";
export var closeButtonContainer = "_na-3";
export var iconContainer = "_na-1";